//Librerias
import React, {useState, useEffect, useContext, useRef, useMemo} from "react";
import moment from "moment";
import {VictoryPie,  VictoryChart, VictoryBar, VictoryStack, VictoryAxis, VictoryLine, VictoryTheme, VictoryLegend} from 'victory';

//Contextos
import controlContext from "../../context/control/controlContext";
import usuariosContext from "../../context/usuarios/usuariosContext";

//Componentes
import AddFilter from "../addFilter/AddFilter";
import SearchInput from "../searchInput/SearchInput";
import FilterScreen from "../filterScreen/FilterScreen";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

//Utiles
import { STATES } from "../../utils/states";

import './Dashboard.css';
import { colors } from "@mui/material";
import { filtrosToString } from "../../utils/funciones";

const DashboardODT = ({setGridToShow, usuario}) => {

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango, 
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        filtrar,
        infoTDocs,
        getInfoDashboardODT,
        iniciarFiltrosGetInfoODTs,
    } = cContext;

    const uContext = useContext(usuariosContext);
    const {userListView, saveColumnsPreferences} = uContext

    const [selct,setSelec] = useState([]);
    const [info, setInfo] = useState(null);
    const [filter,setFilter] = useState('');
    const [loading,setLoading] = useState(true);
    const [showFilter,setShowFilter] = useState(false);
    const [totalizadores,setTotalizadores] = useState(null);
    const [infoModelated,setInfoModelated] = useState(null);
    const [activeWorkSpace, setActiveWorkSpace] = useState({todos: 1, pendientes: 0, disponibles:0 });

    const firstLoadRef = useRef(true);

    const handlerIniciarlizarFiltros = async () => {
        const state = STATES;
        let res = await iniciarFiltrosGetInfoODTs(state, usuario);
        return res;
    }

    const apFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    useEffect(()=>{
            if(firstLoadRef.current){
                console.log("Primer carga");
                firstLoadRef.current = false;
                const fn = async() =>{
                    handlerIniciarlizarFiltros()
                    .then(res => {
                        console.log(res);
                        setLoading(false); //Me aseguro de quitar el cargando al saber que listTDoc del contexto control esta actualizada.
                    })
                }
                fn();
            } else {
                console.log("Ya paso la primer carga");
                setLoading(true);
                getInfoDashboardODT(usuario._id, filtrosRango, filtrosEstado)
                .then(res => {
                    setLoading(false);
                })
            }
            
    },[filtrosRango,filtrosEstado])  

    useEffect(()=>{
        if(infoTDocs){
            let estados = [{x:"Pendientes", y: infoTDocs.pendientes}, {x:"En Nivel3", y: infoTDocs.progreso}, {x:"Finalizadas", y: infoTDocs.completados}]
            let prioridad = [{x:"Media", y: infoTDocs.prioridadMedia}, {x:"Alta", y: infoTDocs.prioridadAlta}, {x:"Urgente", y: infoTDocs.prioridadUrgente}]
            let origen = [{x:"Reactivos", y: infoTDocs.reactivos, x:"Calculados", y: infoTDocs.calculados}] 

            setInfoModelated({...infoModelated, ...infoTDocs, estados, prioridad, origen});
        }else{
            
        }
    },[infoTDocs])

    const colorScalePriority = useMemo(()=>{
        if(infoModelated?.prioridad){
            let colorScale = [];
            for(let i = 0; i < infoModelated.prioridad.length; i++){
                if(infoModelated.prioridad[i].y > 0){
                    switch(i){
                        case 0:
                            colorScale.push('green');
                            break;
                        case 1:
                            colorScale.push('orange');
                            break;
                        case 2:
                            colorScale.push('red');
                            break;
                    }
                }
            }
            return colorScale;
        }
    },[infoModelated])
    
    const colorScaleStatus = useMemo(()=>{
        if(infoModelated?.estados){
            let colorScale = [];
            for(let i = 0; i < infoModelated.estados.length; i++){
                if(infoModelated.estados[i].y > 0){
                    switch(i){
                        case 0:
                            colorScale.push('gray');
                            break;
                        case 1:
                            colorScale.push('lightblue');
                            break;
                        case 2:
                            colorScale.push('#06b698');
                            break;
                    }
                }
            }
            return colorScale;
        }
    },[infoModelated])

    return <div className="dashboardParentContainer">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
            <FilterScreen verFiltro={setShowFilter}/>
        </div>
        {
            loading ? <h3 className="warningStatusMsg">Estamos modelando sus datos<span>.</span><span>.</span><span>.</span></h3> : infoModelated && <div className="dashboardsDiv">
                <div className="dashboard" id="mainGraphic">
                    <h3>Creados Vs Completados</h3>
                    <div className="infoContainer">
                        <div className="numbersDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.creados}</h4>
                                <label className="orangeColor">Creadas</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.completados}</h4>
                                <label className="greenColor">Completadas</label>
                                <div className="subCountDiv">
                                    <span className="subCount">
                                        <b>{infoModelated.completadosConTareasSinCompletar}</b> Con tareas sin completar
                                    </span>
                                    <span className="subCount">
                                        <b>{infoModelated.completados100}</b> Completadas 100%
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="percentageDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.porcentajeCompletados}%</h4>
                                <label>Porcentaje Completadas</label>
                            </div>
                        </div>
                    </div>
                    <div>
                        <VictoryChart theme={VictoryTheme.material} domainPadding={20} height={200} width={750}>
                            {/* X Axis */}
                            <VictoryAxis
                                style={{
                                    tickLabels: { fontSize: 8, padding: 5 } // reduce font size here
                                }}
                            />

                            {/* Y Axis */}
                            <VictoryAxis dependentAxis />

                            <VictoryLine 
                                data={infoModelated.creadosPerMonth} 
                                labels={({datum}) => datum.y}
                                style={{
                                    data: { stroke: "orange", strokeWidth: 2 },
                                    labels: { fontSize: 10 }
                                }}
                            />
                            <VictoryLine 
                                data={infoModelated.completadosPerMonth} 
                                labels={({datum}) => datum.y}
                                style={{
                                    data: { stroke: "green", strokeWidth: 2 },
                                    labels: { fontSize: 10 }
                                }}
                            />
                        </VictoryChart>
                    </div>
                </div>
                <div className="dashboard">
                    <h3>Reactivos Vs Calculados</h3>
                    <div className="infoContainer columnContainer">
                        <div className="numbersDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.reactivos}</h4>
                                <label className="violetColor">Reactivos</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.calculados}</h4>
                                <label className="yellowColor">Calculados</label>
                            </div>
                        </div>
                        <div className="percentageDiv">
                        <VictoryChart domainPadding={30} width={300} height={350} >
                            <VictoryStack colorScale={["rgb(240, 61, 240)", "rgb(233, 233, 4)"]}>
                                <VictoryBar
                                    barWidth={40}
                                    style={{
                                        labels:{fontSize:10}
                                    }} 
                                    data={[{x:"Reactivos", y: infoModelated.reactivos}]}
                                />
                                <VictoryBar 
                                    barWidth={40}
                                    style={{
                                        labels:{fontSize:10}
                                    }} 
                                    data={[{x:'Calculados', y: infoModelated.calculados}]}
                                />
                            </VictoryStack>
                        </VictoryChart>
                        </div>
                    </div>
                </div>
                <div className="dashboard" id="firstColumns">
                    <h3>Estado</h3>
                    <div className="infoContainer">

                        <div className="numbersDiv columnDirection">
                            <div className="numbersData">
                                <h4>{infoModelated.pendientes}</h4>
                                <label className="greyColor">Pendientes</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.progreso}</h4>
                                <label className="lightblueColor">En Nivel3</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.completados}</h4>
                                <label className="turquoiseColor">Finalizadas</label>
                            </div>
                        </div>

                        <div className="percentageDiv">
                            <VictoryPie
                                data={infoModelated ? infoModelated.estados.filter(e => e.y > 0) : []}
                                colorScale={colorScaleStatus}
                                radius={100}
                                innerRadius={50}
                                labels={({ datum }) => `${datum.x}:\n ${((datum.y / infoModelated?.creados) * 100).toFixed(2)}%`}
                            />
                        </div>

                    </div>

                </div>
                <div className="dashboard" id="secondColumns">
                    <h3>Prioridad</h3>
                    <div className="infoContainer">
                        <div className="numbersDiv columnDirection" >
                            <div className="numbersData">
                                <h4>{infoModelated.prioridadMedia}</h4>
                                <label className="greenColor">Media</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.prioridadAlta}</h4>
                                <label className="orangeColor">Alta</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.prioridadUrgente}</h4>
                                <label className="redColor">Urgente</label>
                            </div>
                        </div>
                        <div className="percentageDiv">
                            <VictoryPie
                                data={infoModelated ? infoModelated.prioridad.filter(p => p.y > 0) : []}
                                colorScale={colorScalePriority}
                                radius={100}
                                innerRadius={50}
                                labels={({ datum }) => `${datum.x}:\n ${((datum.y / infoModelated.creados) * 100).toFixed(2)}%`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        }
        {showFilter && <div className="addFilterContainer">
            <AddFilter
                usuarios={userListView} 
                item={''} 
                cerrar={()=>setShowFilter(false)} 
                filtro={{filtrosRango, filtrosEstado}} 
                aplicarFiltros={apFiltros} 
                workspace={activeWorkSpace} 
                selct={selct}
                setSelec={setSelec}
            />
        </div> }
    </div>

}

export default DashboardODT;